import { useContent, useFormattedContent } from 'src/contexts/ContentContext';
import { useEventMetrics } from 'src/contexts/EventMetricsContext';
import { PosEnumSelect } from 'src/core/POS/PosSelect/PosEnumSelect';
import { useMatchMedia } from 'src/hooks/useMatchMedia';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { FormatContentId } from 'src/utils/constants/formatContentId';
import {
  Feature,
  SellerEventDashboardMetricsTimePeriod,
} from 'src/WebApiController';

import * as dashboardStyles from '../../DashboardSection.css';
import { HeaderWidgetContainer } from '../../HeaderWidgetContainer';
import { SellerEventPerformanceMetricWidgetsBody } from './SellerEventPerformanceMetricWidgetsBody';
import { SellerEventPerformanceMetricWidgetsBodyMobile } from './SellerEventPerformanceMetricWidgetsBodyMobile';

export const SellerEventPerformanceMetricWidgetsContainer = () => {
  const { performanceMetrics } = useEventMetrics();

  const hasMobileInventoryPageFeature = useUserHasFeature(
    Feature.MobileInventoryEventPage
  );
  const isMobileLayout =
    useMatchMedia('mobile') && hasMobileInventoryPageFeature;

  const yourStatsText = useContent(ContentId.YourStats);
  const allTimeText = useContent(ContentId.AllTime);
  const last7DaysText = useFormattedContent(
    FormatContentId.LastNDays,
    '7'
  ) as string;
  const timePeriodValueOptionsContent = {
    [SellerEventDashboardMetricsTimePeriod.Last7Days]: last7DaysText,
    [SellerEventDashboardMetricsTimePeriod.AllTime]: allTimeText,
  };

  return (
    <>
      <HeaderWidgetContainer
        title={yourStatsText}
        action={
          <PosEnumSelect
            className={dashboardStyles.dashboardHeaderSelect}
            value={performanceMetrics.timePeriod}
            valueOptionsContent={timePeriodValueOptionsContent}
            onChange={performanceMetrics.updateTimePeriod}
            shape="none"
          />
        }
      />
      {isMobileLayout ? (
        <SellerEventPerformanceMetricWidgetsBodyMobile
          performanceMetrics={performanceMetrics.metrics}
          isLoading={performanceMetrics.isLoading}
        />
      ) : (
        <SellerEventPerformanceMetricWidgetsBody
          performanceMetrics={performanceMetrics.metrics}
          isLoading={performanceMetrics.isLoading}
        />
      )}
    </>
  );
};
